export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export const BUTTON_VARIANTS: Readonly<Record<ButtonVariant, string>> = {
  primary: 'bg-brass text-brass-ink hover:brightness-95 active:brightness-90',
  secondary: 'border border-field bg-card text-ink hover:bg-paper',
  ghost: 'text-ink hover:bg-ink/5',
  danger: 'border border-debit text-debit hover:bg-debit/10',
};
